import React, { useEffect, useState } from "react";
import { http } from "../lib/api";
import { toast } from "sonner";
import { Mail, Phone, Building2, MessageSquare, X, Trash2 } from "lucide-react";

const ESTADOS = ["nuevo", "atendido", "cerrado"];

export default function AdminMensajes() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");
  const [selected, setSelected] = useState(null);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await http.get("/admin/mensajes");
      setItems(data || []);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const updateEstado = async (id, estado) => {
    try { await http.patch(`/admin/mensajes/${id}`, { estado }); toast.success("Actualizado"); load(); setSelected((s) => s ? { ...s, estado } : s); }
    catch { toast.error("Error"); }
  };
  const remove = async (id) => {
    if (!window.confirm("¿Eliminar mensaje?")) return;
    try { await http.delete(`/admin/mensajes/${id}`); toast.success("Eliminado"); load(); setSelected(null); }
    catch { toast.error("Error"); }
  };

  const filtered = filter ? items.filter((m) => m.estado === filter) : items;

  return (
    <div data-testid="admin-mensajes">
      <div className="mb-6">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight" style={{ fontFamily: "Manrope" }}>Mensajes de contacto</h1>
        <p className="text-sm mt-1" style={{ color: "var(--text-muted)" }}>Solicitudes recibidas desde el formulario público.</p>
      </div>

      <div className="flex gap-2 mb-5 flex-wrap">
        <button onClick={() => setFilter("")} className={`yn-btn ${filter === "" ? "yn-btn--active-yes" : ""}`}>Todos</button>
        {ESTADOS.map((e) => (
          <button key={e} onClick={() => setFilter(e)} className={`yn-btn ${filter === e ? "yn-btn--active-yes" : ""}`} data-testid={`filter-${e}`}>{e}</button>
        ))}
      </div>

      <div className="bg-white border rounded-xl overflow-hidden" style={{ borderColor: "var(--border-subtle)" }}>
        {loading ? <div className="p-10 text-center text-sm" style={{ color: "var(--text-muted)" }}>Cargando…</div>
         : filtered.length === 0 ? (
          <div className="p-10 text-center">
            <MessageSquare size={36} className="mx-auto mb-3" style={{ color: "var(--text-muted)" }}/>
            <div className="font-bold mb-1" style={{ fontFamily: "Manrope" }}>Sin mensajes</div>
            <div className="text-sm" style={{ color: "var(--text-muted)" }}>Cuando alguien envíe el formulario aparecerá aquí.</div>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="tbl">
              <thead><tr><th>Nombre</th><th>Comunidad/Empresa</th><th>Email</th><th>Teléfono</th><th>Origen</th><th>Estado</th><th>Fecha</th><th></th></tr></thead>
              <tbody>
                {filtered.map((m) => (
                  <tr key={m.id}>
                    <td className="font-semibold">{m.nombre}</td>
                    <td>{m.comunidad_empresa}</td>
                    <td className="text-[13px]">{m.email}</td>
                    <td className="text-[13px]">{m.telefono}</td>
                    <td><span className="text-[11px] uppercase tracking-[0.1em] font-bold px-2 py-0.5 rounded" style={{ background: "var(--bg-soft)", color: "var(--text-muted)" }}>{m.origen}</span></td>
                    <td><span className={`badge badge--${m.estado === "nuevo" ? "nueva" : m.estado === "atendido" ? "en_revision" : "cerrada"}`}>{m.estado}</span></td>
                    <td className="text-[12px]" style={{ color: "var(--text-muted)" }}>{(m.created_at || "").slice(0,10)}</td>
                    <td><button onClick={() => setSelected(m)} className="text-sm font-semibold" style={{ color: "var(--brand-accent)" }}>Ver</button></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {selected && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(10,37,64,0.55)" }} onClick={() => setSelected(null)}>
          <div className="bg-white rounded-xl max-w-lg w-full max-h-[90vh] overflow-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between p-5 border-b sticky top-0 bg-white" style={{ borderColor: "var(--border-subtle)" }}>
              <h3 className="font-bold text-lg" style={{ fontFamily: "Manrope" }}>{selected.nombre}</h3>
              <button onClick={() => setSelected(null)}><X size={20}/></button>
            </div>
            <div className="p-5 space-y-4">
              <div className="space-y-3 text-sm">
                <a href={`mailto:${selected.email}`} className="flex items-center gap-3 group">
                  <Mail size={16} style={{ color: "var(--brand-navy)" }}/>
                  <span className="group-hover:underline">{selected.email}</span>
                </a>
                <a href={`tel:${selected.telefono}`} className="flex items-center gap-3 group">
                  <Phone size={16} style={{ color: "var(--brand-navy)" }}/>
                  <span className="group-hover:underline">{selected.telefono}</span>
                </a>
                <div className="flex items-center gap-3">
                  <Building2 size={16} style={{ color: "var(--brand-navy)" }}/>
                  <span>{selected.comunidad_empresa}</span>
                </div>
              </div>
              {selected.mensaje && (
                <div className="pt-3 border-t" style={{ borderColor: "var(--border-subtle)" }}>
                  <div className="text-[11px] uppercase tracking-[0.15em] font-bold mb-2" style={{ color: "var(--text-muted)" }}>Mensaje</div>
                  <p className="text-sm whitespace-pre-wrap">{selected.mensaje}</p>
                </div>
              )}
              <div className="pt-3 border-t" style={{ borderColor: "var(--border-subtle)" }}>
                <div className="text-[11px] uppercase tracking-[0.15em] font-bold mb-2" style={{ color: "var(--text-muted)" }}>Cambiar estado</div>
                <div className="flex gap-2">
                  {ESTADOS.map((e) => (
                    <button key={e} onClick={() => updateEstado(selected.id, e)} className={`yn-btn ${selected.estado === e ? "yn-btn--active-yes" : ""}`}>{e}</button>
                  ))}
                </div>
              </div>
            </div>
            <div className="p-5 border-t flex justify-end gap-3 sticky bottom-0 bg-white" style={{ borderColor: "var(--border-subtle)" }}>
              <button className="text-sm font-semibold inline-flex items-center gap-1" style={{ color: "#D32F2F" }} onClick={() => remove(selected.id)}><Trash2 size={14}/>Eliminar</button>
              <button onClick={() => setSelected(null)} className="btn-outline ml-auto">Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
